(function($){
    'use strict';

    var $html = $('html'),
        $headerSkip = $('.js-header-skip a'),
        $headerTip = $('.js-header-tip'),
        $headerSearchToggle = $('.js-header-search-toggle button'),
        $headerSearch = $('.js-header-search');

    $headerSkip.click(function(){
        var $anchorContent = $($(this).attr('href'));

        $('html, body').animate({
            scrollTop: $anchorContent.offset().top
        }, 300, function(){
            $anchorContent.attr('tabindex', -1).on('blur focusout', function () {
                $(this).removeAttr('tabindex');
            }).focus();
        });

        return false;
    });

    $headerSearchToggle.click(function() {
        if($headerSearchToggle.hasClass('active')) {
            $headerSearchToggle.removeClass('active');
            $headerSearch.slideUp(300, function() {
                $headerSearch.removeAttr('style').removeClass('active');
            });
        } else {
            $headerSearchToggle.addClass('active');
            $headerSearch.slideDown(300, function() {
                $headerSearch.addClass('active').removeAttr('style');
            });

        }
    });
}(jQuery));